export default String.raw`
{% include 'partials/common/date-format.html' -%}

{% assign discountsERP = customer-profile.DiscountsERP -%}
{% assign discountString = customer-profile.DiscountQueryGET | H -%}
{% assign paginationPageNo = discountsERP.PageNo -%}
{% assign anyDiscount = false -%}
{% assign showValueColumn = false -%}
{% assign showPriceRangeColumn = false -%}

{% assign orderValuesSize = customer-profile.DiscountsEshop.OrderValue | Size -%}

{% if paginationPageNo == 1 -%}
    {% if orderValuesSize > 0 or customer-profile.DiscountsEshop.Regular or customer-profile.DiscountsEshop.FirstOrder -%}
        {% assign showValueColumn = true -%}
    {% endif -%}
    
    {% if orderValuesSize > 0 -%}
        {% for orderValue in customer-profile.DiscountsEshop.OrderValue -%}
            {% if orderValue.ValueFrom or orderValue.ValueTo -%}
                {% assign showPriceRangeColumn = true -%}
                {% break -%}
            {% endif -%}
        {% endfor -%}
    {% endif -%}
{% endif -%}

<div class="eshop__table-container discounts">
    <table data-template="partials/customer-profile/discounts/discount-details.html">
        <colgroup>
            <col style="width:250px">
            {% if showValueColumn -%}
                <col style="width:250px">
            {% endif -%}
            {% if showPriceRangeColumn -%}
                <col style="width:150px">
            {% endif -%}
        </colgroup>
        <thead>
            <tr>
                <th class="id">{{ translations.DiscountName | Capitalize }}</th>
                <th>{{ translations.ExpirationDate }}</th>
                {% if showValueColumn -%}
                    <th>{{ translations.Value }}</th>
                {% endif -%}
                {% if showPriceRangeColumn -%}
                    <th>{{ translations.PriceRange }}</th>
                {% endif -%}
            </tr>
        </thead>
        {% if paginationPageNo == 1 -%}
            {% if orderValuesSize > 0 -%}
                <tbody>
                    {% assign anyDiscount = true -%}
                    {% for orderValue in customer-profile.DiscountsEshop.OrderValue -%}
                        <tr class="row no-hover">
                            <td class="id">{{ translations.FromOrderValue }}</td>
                            <td>
                                {% if orderValue.DateTill -%}
                                    {{ translations.ValidTo | Downcase }}: {{ orderValue.DateTill | Date:dateFormat }}
                                {% else -%}
                                    {{ translations.ValidLifetime | Downcase }}
                                {% endif -%}
                            </td>
                            <td>{{ orderValue.Discount | Normalize }} %</td>
                            {% if showPriceRangeColumn -%}
                                <td>
                                    {{ orderValue.ValueFrom }} {{ customer.CurrencyExt }} - {{ orderValue.ValueTo }} {{ customer.CurrencyExt }}
                                </td>
                            {% endif -%}
                        </tr>
                    {% endfor -%}
                </tbody>
            {% endif -%}

            {% if customer-profile.DiscountsEshop.Regular -%}
                {% assign anyDiscount = true -%}
                {% assign regular = customer-profile.DiscountsEshop.Regular -%}
                <tbody>
                    <tr class="row no-hover">
                        <td class="id">{{ translations.ForRegularCustomer }}</td>
                        <td>
                            {% if regular.DateTill -%}
                                {{ translations.ValidTo | Downcase }}: {{ regular.DateTill | Date:dateFormat }}
                            {% else -%}
                                {{ translations.ValidLifetime | Downcase }}
                            {% endif -%}
                        </td>
                        <td>{{ regular.Discount | Normalize }} %</td>
                        {% if showPriceRangeColumn -%}
                            <td></td>
                        {% endif -%}
                    </tr>
                </tbody>
            {% endif -%}

            {% if customer-profile.DiscountsEshop.FirstOrder -%}
                {% assign anyDiscount = true -%}
                {% assign firstOrder = customer-profile.DiscountsEshop.FirstOrder -%}
                <tbody>
                    <tr class="row no-hover">
                        <td class="id">{{ translations.ForNewCustomer }}</td>
                        <td>
                            {% if firstOrder.DateTill -%}
                                {{ translations.ValidTo | Downcase }}: {{ firstOrder.DateTill | Date:dateFormat }}
                            {% else -%}
                                {{ translations.ValidLifetime | Downcase }}
                            {% endif -%}
                        </td>
                        <td>{{ firstOrder.Discount | Normalize }} %</td>
                        {% if showPriceRangeColumn -%}
                            <td></td>
                        {% endif -%}
                    </tr>
                </tbody>
            {% endif -%}
        {% endif -%}

        {% if discountsERP.TotalItems > 0 -%}
            <tbody>
                {% assign anyDiscount = true -%}
                {% for discount in discountsERP.Discounts -%}
                    <tr tabindex="0" class="row can-hover load-deeper-lvl-js parent-container-reload-js" data-id="{{ discount.Id }}" data-url="{{ page.Url }}?{{ discountString }}={{ discount.Id }}&deeper-lvl&tab=discount-details">
                        <td class="id">
                            {% if discount.Name != null -%}
                                {{ discount.Name | H }}
                            {% else -%}
                                {{ translations.AllProducts }}
                            {% endif -%}
                        </td>
                        <td>
                            {% if discount.DateTill -%}
                                {% if discount.DateFrom -%}
                                    {{ translations.ValidFrom | Downcase }}: {{ discount.DateFrom | Date:dateFormat }}<br>
                                {% endif -%}
                                {{ translations.ValidTo | Downcase }}: {{ discount.DateTill | Date:dateFormat }}
                            {% else -%}
                                {{ translations.ValidLifetime | Downcase }}
                            {% endif -%}
                        </td>
                        {% if showValueColumn -%}
                            <td></td>
                        {% endif -%}
                        {% if showPriceRangeColumn -%}
                            <td></td>
                        {% endif -%}
                    </tr>
                {% endfor -%}
            </tbody>
        {% endif -%}
    </table>
</div>

{% if discountsERP.TotalItems > 0 %}
    {% include 'partials/common/pagination.html' -%}
{% endif %}
{% unless anyDiscount -%}
    <div class="no-data">{{ translations.NoDicountsInfo }}</div>
{% endunless -%}
`